<template>
  <div>
    <div class="modal-bg" :class=modalbgCustom></div>

    <div class="
        modal-wrap-container
        grid
        fixed
        inset-0
        h-screen
        w-screen
        justify-center
        items-start
      ">
      <div class="modal-wrap rounded-2xl mt-16 p-6 relative w-screen" :class="modalClass + ' ' + modalWidth">
        <div class="absolute top-4 right-4">
          <a href="#" @click.stop.prevent="toggleModal" class="text-lg font-light">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
              <path
                d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" />
            </svg>
          </a>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  wide: {
    type: Boolean,
    default: false,
  },
  customwidth: {
    type: String,
    default: "",
  },
  modalbgCustom: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["hideModal"]);

const modalClass = computed(() => props.wide ? "modal-wrap-wide" : "modal-wrap-regular");

const modalWidth = computed(() => props.customwidth || "");

const toggleModal = () => {
  emit("hideModal");
};
</script>

<style scoped>
.modal-bg {
  background: rgba(100, 100, 100, 0.5);
  text-align: center;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.modal-wrap-container {
  z-index: 10000;
  overflow: auto;
}

.modal-wrap {
  background: #fff;
  min-height: 100px;
  height: auto;
  max-width: 1024px;
}

.small-size-30 {
  max-width: 30vw !important;
}

.modal-bg-blur {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(7px);
  /* Apply the blur effect */
}

@media (min-width: 1024px) {
  .modalWidth-unset {
    max-width: unset;
  }

  .modalWidth-1250 {
    max-width: 1250px;
  }

  .modal-wrap-regular {
    width: 50vw;
  }

  .modal-wrap-wide {
    width: 80vw;
  }
}

.modal-close {
  right: 10px;
  top: 10px;
  line-height: 1;
}

path {
  fill: #517185;
}
</style>
